import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import EyeOpen from "@/components/icons/EyeOpen.vue";
import EyeSlash from "@/components/icons/EyeSlash.vue";
import DownArrow from "@/components/icons/DownArrow.vue";
import CalendarRed from "@/components/icons/CalendarRed.vue";
import TimeRed from "@/components/icons/TimeRed.vue";
import ProxyRed from "@/components/icons/ProxyRed.vue";
import SearchBefore from "@/components/icons/SearchBefore.vue";
import AtMessage from "@/components/icons/AtMessage.vue";
import MessageBtnActive from "@/components/icons/MessageBtnActive.vue";
import MessageBtn from "@/components/icons/MessageBtn.vue";
// import SalaryChart from "@/components/icons/SalaryChart.vue";
import SalaryChart2 from "@/components/icons/SalaryChart2.vue";
import AnnualIncome from "@/components/icons/AnnualIncome.vue";
import YearendBonus from "@/components/icons/YearendBonus.vue";
import PerformanceBonus from "@/components/icons/PerformanceBonus.vue";
import SalaryIncome from "@/components/icons/SalaryIncome.vue";
// import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // primary: "#007BFF",
        // secondary: "#424242",
        primary: "#FD4B03", // 主色橘紅
        secondary: "#FEA801", // 主色黃
        assistRed: "#FF0000", // 輔助紅
        // assistYellow: "#FCB206", // 輔助黃
        // assistOrange: "#FA8B00", // 輔助橘
        accent: "#82B1FF",
        error: "#FF5252",
        // info: "#2196F3",
        info: "#000000",
        success: "#4CAF50",
        // warning: "#FFC107",
        warning: "#1636E3",
      },
    },
  },
  icons: {
    iconfont: "fa",
    values: {
      eip_eye: {
        component: EyeOpen,
      },
      eip_eye_close: {
        component: EyeSlash,
      },
      eip_down_arrow: {
        component: DownArrow,
      },
      eip_calendar: {
        component: CalendarRed,
      },
      eip_time: {
        component: TimeRed,
      },
      eip_proxy: {
        component: ProxyRed,
      },
      eip_search: {
        component: SearchBefore,
      },
      eip_message: {
        component: AtMessage,
      },
      eip_message_btn_active: {
        component: MessageBtnActive,
      },
      eip_message_btn: {
        component: MessageBtn,
      },
      // eip_salary_chart: {
      //   component: SalaryChart,
      // },
      eip_salary_chart: {
        component: SalaryChart2,
      },
      eip_annual_income: {
        component: AnnualIncome,
      },
      eip_yearend_bonus: {
        component: YearendBonus,
      },
      eip_performance_bonus: {
        component: PerformanceBonus,
      },
      eip_salary_income: {
        component: SalaryIncome,
      },
    },
  },
});
